import { DateUnits } from "@clintonelec/typescriptutils";
import { Filters } from "Data/Objects/UI";

export type DateString = string;

export interface IItemFilters {
	orderNumber: string;
	scannedAfter: DateString | null;
	scannedBefore: DateString | null;
	scanDateOption: ScanDateFilterOptions | null;
	selectedPartNumbers: string[];
	serialDateLower: DateString | null;
	serialDateUpper: DateString | null;
	serialNumber: string;
	serialRangeLower: string;
	serialRangeUpper: string;
}

export enum ScanDateFilterOptions {
	TODAY = DateUnits.DAYS,
	WEEK = 7 * DateUnits.DAYS,
	THIRTY_DAYS = 30 * DateUnits.DAYS,
	NINETY_DAYS = 90 * DateUnits.DAYS,
	YEAR = 365 * DateUnits.DAYS,
	CUSTOM = 0
}

export interface ISetFilterPayload {
	filter: Filters;
	value: string;
}

export type IFilters = {
	[ key in Filters ]: string;
};

export type UiState = {
	scanDateOption: ScanDateFilterOptions | null;
	selectedItems: string[];
	filters: IFilters;
};
